module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("aoai4"))).then(() => parcelRequire('hEqeo'));